/**
 * Utility function to format email addresses or names for display
 * Converts email addresses to readable names and formats existing names
 * 
 * Examples:
 * - "nilesh.chakkar@maersk.com" → "Nilesh Chakkar"
 * - "m.h.javed@maersk.com" → "M. H. Javed"
 * - "John Doe" → "John Doe" (unchanged if not an email)
 * 
 * @param {string|object} input - Email address, name string, or object with name/email properties
 * @returns {string} Formatted display name
 */
export const formatAssignedToDisplay = (input) => {
  // Handle null/undefined
  if (!input) return "Not Yet Assigned";

  let value = input;

  // Handle object case (extract name or email)
  if (typeof input === 'object' && input !== null) {
    value = input.displayName ||
            input.label || 
            input.name ||
            input.value || 
            input.email ||
            input.userPrincipalName ||
            input.mail;
    
    if (!value) return "Not Yet Assigned";
  }

  // Convert to string
  value = String(value).trim();
  
  if (!value) return "Not Yet Assigned";

  // If it's an email, extract and format the name part
  if (value.includes('@')) {
    // Extract the part before @
    const namePart = value.split('@')[0];
    
    // Split by dots or underscores
    const parts = namePart.split(/[._]/);
    
    // Capitalize each part
    const formatted = parts
      .map(part => {
        if (!part) return '';
        // Handle single letters (like "m" or "h")
        if (part.length === 1) {
          return part.toUpperCase() + '.';
        }
        // Capitalize first letter of each word
        return part.charAt(0).toUpperCase() + part.slice(1).toLowerCase();
      })
      .join(' ')
      .trim();
    
    return formatted || "Not Yet Assigned";
  }

  // If it's already a name (no @), return as is
  return value;
};
